/**
 * Pre-compiled en messages for ModalPage
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  backButton: (args: Record<string, string | number>) =>
    `Go back to ${args.previousPathLabel}`,
};
